/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint-disable-next-line max-len */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["state", "payload"] }] */

import api from '../../utils/api';

const state = {
  loading: false,
  currentUser: {},
  card: null,
  orderHistory: [],
  customs: [],
  submissions: [],
  acceptedSubmissions: [],
};

const getters = {
  favoritesTotal(state) {
    let total = 0;
    if (state.currentUser && state.currentUser.favorites) {
      total += state.currentUser.favorites.hats.length;
      total += state.currentUser.favorites.patches.length;
    }
    return total;
  },
};

const mutations = {
  setLoading(state, { loading }) {
    state.loading = loading;
  },
  // USER DATA
  setCurrentUser(state, currentUser) {
    state.currentUser = currentUser;
    if (!currentUser.shippingAddress) {
      state.currentUser.shippingAddress = {};
    }
    if (!currentUser.favorites) {
      state.currentUser.favorites = {
        hats: [],
        patches: [],
      };
    }
  },
  setEmailAddress(state, emailAddress) {
    state.currentUser.email = emailAddress;
  },
  setAlias(state, alias) {
    state.currentUser.alias = alias;
  },
  setShippingAddress(state, shippingAddress) {
    state.currentUser.shippingAddress = shippingAddress;
  },
  // FAVORITES
  setEmptyFavoritesObject(state) {
    const favorites = {
      hats: [],
      patches: [],
    };
    state.currentUser.favorites = favorites;
  },
  setFavoritesItem(state, { itemSet, itemId }) {
    const itemIndex = state.currentUser.favorites[itemSet].indexOf(itemId);
    if (itemIndex < 0) {
      state.currentUser.favorites[itemSet].push(itemId);
    }
    if (itemIndex >= 0) {
      state.currentUser.favorites[itemSet].splice(itemIndex, 1);
    }
  },

  setCard(state, card) {
    state.card = card;
  },

  // ORDER HISTORY
  setOrderHistory(state, orderHistory) {
    state.orderHistory = orderHistory;
  },

  // CUSTOMER PATCHES
  setCustoms(state, customs) {
    state.customs = customs;
  },
  setSubmissions(state, submissions) {
    state.submissions = submissions;
  },
  setAcceptedSubmissions(state, acceptedSubmissions) {
    state.acceptedSubmissions = acceptedSubmissions;
  },

};

const actions = {
  getUser({ commit }, id) {
    api
      .getData(`/customers/${id}`)
      .then((res) => {
        const customer = res.data;
        const { customs } = res.data;
        const { submissions } = res.data;
        delete customer.customs;
        delete customer.submissions;
        commit('setCurrentUser', customer);
        commit('setCustoms', customs);
        commit('setSubmissions', submissions);
      })
      .catch(() => {
      // dispatch('clearUser');
      });
  },
  clearUser({ commit }) {
    commit('setCurrentUser', {});
  },
  updateUserProfile({ commit, dispatch }, { accountDetails, shippingAddress }) {
    return new Promise((resolve) => {
      commit('setEmailAddress', accountDetails.emailAddress);
      commit('setAlias', accountDetails.alias);
      commit('setShippingAddress', shippingAddress);

      dispatch('updateCurrentUser');
      resolve();
    });
  },
  // eslint-disable-next-line
  changePassword({}, { publicId, password }) {
    return new Promise((resolve) => {
      api
        .putData('/auth/change', { publicId, password })
        .then(() => {
          resolve();
        });
      resolve();
    });
  },
  toggleItemInFavorites({ state, commit, dispatch }, { itemSet, itemId }) {
    if (!state.currentUser.favorites) {
      commit('setEmptyFavoritesObject');
    }
    return new Promise((resolve) => {
      commit('setFavoritesItem', { itemSet, itemId });
      dispatch('updateCurrentUser');
      resolve();
    });
  },
  // API CALL
  updateCurrentUser({ state, commit }) {
    api
      .putData(
        `/customers/${state.currentUser.publicId}`,
        state.currentUser,
      )
      .then((res) => {
        const updatedCustomerData = res.data;
        commit('setCurrentUser', updatedCustomerData);
      });
  },

  clearCard({ commit }) {
    commit('setCard', null);
  },
  getStripeCard({ commit }, id) {
    return new Promise((resolve, reject) => {
      api
        .getData(`/payments/${id}`)
        .then((res) => {
          const card = res.data;
          if (card.brand === 'None') {
            commit('setCard', null);
            resolve();
          } else {
            commit('setCard', card);
            resolve();
          }
        })
        .catch(() => {
          reject();
        });
    });
  },
  addStripeCard({ commit }, requestData) {
    return new Promise((resolve, reject) => {
      api
        .postData('/payments/', requestData)
        .then((res) => {
          const card = res.data;
          if (card.brand === 'None') {
            commit('setCard', null);
            resolve();
          } else {
            commit('setCard', card);
            resolve();
          }
        })
        .catch(() => {
          reject();
        });
    });
  },
  removeStripeCard({ commit }, id) {
    return new Promise((resolve, reject) => {
      api
        .deleteData(`/payments/${id}`)
        .then(() => {
          commit('setCard', null);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  },

  // Order History
  getAllOrders({ commit }, publicId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', { loading: true });
      api
        .getData(`/orders/${publicId}`)
        .then((res) => {
          const orderHistory = res.data;
          commit('setOrderHistory', orderHistory);
          commit('setLoading', { loading: false });
          resolve();
        })
        .catch((error) => {
          commit('setLoading', { loading: false });
          // commit('setErrorMessage', error);
          reject(error);
        });
    });
  },
  // Customer Patches
  getCustomerCustoms({ commit }, publicId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', { loading: true });
      api
        .getData(`/customers/${publicId}/customs/`)
        .then((res) => {
          const customs = res.data;
          commit('setCustoms', customs);
          commit('setLoading', { loading: false });
          resolve();
        })
        .catch((error) => {
          commit('setLoading', { loading: false });
          // commit('setErrorMessage', error);
          reject(error);
        });
    });
  },
  getCustomerSubmissions({ commit }, publicId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', { loading: true });
      api
        .getData(`/customers/${publicId}/submissions/`)
        .then((res) => {
          const submissions = res.data;
          commit('setSubmissions', submissions);
          commit('setLoading', { loading: false });
          resolve();
        })
        .catch((error) => {
          commit('setLoading', { loading: false });
          // commit('setErrorMessage', error);
          reject(error);
        });
    });
  },
  getCustomerAcceptedSubmissions({ commit }, publicId) {
    return new Promise((resolve, reject) => {
      commit('setLoading', { loading: true });
      api
        .getData(`/customers/${publicId}/accepted_submissions/`)
        .then((res) => {
          const acceptedSubmissions = res.data;
          commit('setAcceptedSubmissions', acceptedSubmissions);
          commit('setLoading', { loading: false });
          resolve();
        })
        .catch((error) => {
          commit('setLoading', { loading: false });
          // commit('setErrorMessage', error);
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
